Handlebars = Handlebars || {};

// register handlebars compare operator
Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
  switch (operator) {
    case '==':
      return (v1 == v2) ? options.fn(this) : options.inverse(this);
    case '===':
      return (v1 === v2) ? options.fn(this) : options.inverse(this);
    case '!=':
      return (v1 != v2) ? options.fn(this) : options.inverse(this);
    case '!==':
      return (v1 !== v2) ? options.fn(this) : options.inverse(this);
    case '<':
      return (v1 < v2) ? options.fn(this) : options.inverse(this);
    case '<=':
      return (v1 <= v2) ? options.fn(this) : options.inverse(this);
    case '>':
      return (v1 > v2) ? options.fn(this) : options.inverse(this);
    case '>=':
      return (v1 >= v2) ? options.fn(this) : options.inverse(this);
    case '&&':
      return (v1 && v2) ? options.fn(this) : options.inverse(this);
    case '||':
      return (v1 || v2) ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
});

// check if any items are truthy
Handlebars.registerHelper('ifSome', function (...items) {
  let options = items.pop();
  return items.some(i => !!i) ? options.fn(this) : options.inverse(this);
});

// check if all items are truthy
Handlebars.registerHelper('ifEvery', function (...items) {
  let options = items.pop();
  return items.every(i => !!i) ? options.fn(this) : options.inverse(this);
});

// iterate an arbitrary number of times
Handlebars.registerHelper('loop', function(n, block) {
  let num = '';
  for (let i = 0; i < n; ++i)
    num += block.fn(i);
  return num;
});

// strip html codes from text
Handlebars.registerHelper('stripHtmlCodes', function(options) {
  let string = options.fn(this);
  // replace any html code, e.g. &reg;
  string = string.replace( /(?=&)(.*?);/g, '');
  // escape string
  string  = Handlebars.escapeExpression(string);
  return new Handlebars.SafeString(string);
});

// print json content
Handlebars.registerHelper('print', function(context) {
  return JSON.stringify(context);
});

// increment value
Handlebars.registerHelper("increment", function(value) {
  return parseInt(value) + 1;
});

// join string values
Handlebars.registerHelper("join", function(separator = '', ...args) {
  let strings = args.slice(0, -1);
  return strings.join(separator);
});

// test if item is an object
Handlebars.registerHelper("isObject", function(item, options) {
  return (typeof item === 'object') ? options.fn(this) : options.inverse(this);
});

// test if item is an array
Handlebars.registerHelper("isArray", function(item, options) {
  return (typeof item === 'object' && Array.isArray(item)) ? options.fn(this) : options.inverse(this);
});